import type { DBFieldAttribute } from "better-auth";

type AdditionalFieldSchema = {
  user: Record<string, DBFieldAttribute>;
  session?: Record<string, DBFieldAttribute>;
};

export const betterAuthAdditionalFieldsSchema = {
  user: {
    firstName: { type: "string", required: false },
    lastName: { type: "string", required: false },
    profileImageUrl: { type: "string", required: false },
  },
} satisfies AdditionalFieldSchema;
